export default "__VITE_ASSET__Cv3imE25__"